import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { TokenService } from '../service/token.service';
import { GlobalConfig } from '../entities/global-config';
@Injectable()
export class AuthService {
  headers: Headers;
  options: RequestOptions;

  constructor(private http: Http, private tokService: TokenService, private config: GlobalConfig) {
    this.headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'q=0.8;application/json;q=0.9' });
    this.options = new RequestOptions({ headers: this.headers });
  }

  login(user: any): Promise<any> {
    const obj = { userName: user.email, password: user.password, grant_type: 'password', client_id: this.config.clientId };
    return this.http
      .post(this.config.apiRootUrl + 'api/token', obj, this.options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  forgotPassword(email: any) {
    return this.http
      .get(this.config.apiRootUrl + 'api/user/forgot/' + email + '/password')
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
    // return this.serviceHttp.get(this.config.apiRootUrl + 'api/user/forgot/' + email + '/password', );
  }

  getExpiryToken(passwordResetToken: any) {
    return this.http
      .get(this.config.apiRootUrl + 'api/users/getExpiryToken/' + passwordResetToken)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  resetPassword(reset: any) {
    return this.http
      .post(this.config.apiRootUrl + 'api/users/resetPassword', reset)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  refreshToken() {

    const promise = new Promise((resolve, reject) => {
      if (this.tokService.isLogin()) {
        if (this.tokService.isRefreshNeeded()) {
          const obj = {
            refresh_token: this.tokService.getRefToken(), userName: '', password: '',
            grant_type: 'refresh_token', client_id: this.config.clientId
          };
          this.http.put(this.config.apiRootUrl + 'api/token', obj, this.options)
            .toPromise()
            .then(
            (responseJson: any) => { // Success
              const body = responseJson.json();
              this.tokService.setToken(body.access_token);
              this.tokService.setRefToken(body.refresh_token);
              resolve(true);
            }
            ).catch(error => {
              this.tokService.logout();
              resolve(false);
            });
        } else {
          resolve(true);
        }
      } else {
        this.tokService.logout();
        resolve(false);
      }
    });

    return promise;
  }

  private extractData(res: Response) {
    const body = res.json();
    return body || {};
  }

  private handleError(error: any): Promise<any> {

    return Promise.reject(error.message || error);
  }
}





// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/service/auth.service.ts